/** Hand-over reasons as the desk writes them in `it_desk_runs.handed_reason`. */
const LABELS: Record<string, string> = {
  no_resolver: 'no way to resolve',
  not_allowed: 'not allowed',
  unclear: 'unclear request',
  limits: 'limits reached',
  incident: 'incident',
  emergency: 'emergency stop',
  cancelled: 'stopped by a person',
}

export function handedReasonLabel(reason: string | null | undefined): string {
  const key = (reason ?? '').trim()
  return LABELS[key] ?? key.replace(/_/g, ' ')
}
